/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';
import {
  CostCenterFinderBusinessService,
  CostCenterFinderDialogConfig,
} from '../resources/cost-center-finder-business.service';
import {
  CostCenterFinderListItem,
  getCostCenterFinderListItemId,
} from '../resources/cost-center-finder-list-item.model';
import { CostCenterGridDefinition } from './cost-center-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-cost-center-finder-dialog',
  templateUrl: 'cost-center-finder-dialog.component.html',
  styleUrls: ['cost-center-finder-dialog.component.scss'],
  providers: [CostCenterGridDefinition],
})
export class CostCenterFinderDialogComponent
  extends AbstractFinderDialogComponent<CostCenterFinderDialogConfig, CostCenterFinderListItem>
  implements OnInit {

  getId = getCostCenterFinderListItemId;

  form: FormState<any>;

  defaultTitle = this.translations.get('lbl_find_cost_centers');

  constructor(public gridDefinition: CostCenterGridDefinition,
              private translations: TranslationService,
              formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: CostCenterFinderBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: {
        name: void 0,
      },
    });
  }

  protected buildDataSource(): SlicedDataSource<CostCenterFinderListItem> {
    return this.businessService.findAllAsDataSource({
      ...(this.input.filter || {}),
      searchString: getControlValue(this.form.group, 'name'),
    });
  }

  protected getDataSourceFilter(): any {
    return { name: getControlValue(this.form.group, 'name') };
  }
}
